import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-template-secondary-large',
  templateUrl: './template-secondary-large.component.html',
  styleUrls: ['./template-secondary-large.component.scss']
})
export class TemplateSecondaryLargeComponent {
  @Input() noPadding = false;
  @Input() border = false;
}
